var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23407 0.129553C5.07184 0.289498 5.05662 0.542236 5.18961 0.719567L5.22955 0.765933L7.975 3.55L0.95 3.55C0.701472 3.55 0.5 3.75147 0.5 4C0.5 4.22941 0.671668 4.41873 0.893553 4.44649L0.95 4.45H7.975L5.22955 7.23407C5.06961 7.3963 5.05798 7.64923 5.19347 7.82465L5.23407 7.87045C5.3963 8.03039 5.64922 8.04202 5.82465 7.90653L5.87045 7.86593L9.37045 4.31593C9.52879 4.15533 9.54198 3.90544 9.41003 3.72996L9.37045 3.68407L5.87045 0.134067C5.69596 -0.0429112 5.41104 -0.0449318 5.23407 0.129553Z",
    fill: "#8F969C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b6b43746faebad2d13340b6cf62ac183.svg";
export { ForwardRef as ReactComponent };